import { createContext, useContext } from 'react';

// ==============================|| CITYZEN - SHARE CONTEXT (global, entity-agnostic) ||============================== //

export type ShareTip = 'proiect' | 'chestionar' | 'anunt';

export interface ShareTarget {
	tip: ShareTip;
	id: string | number;
	title: string;
	image?: string;
	// toate imaginile candidate ale entității — dialogul permite alegerea pozei dintre ele
	images?: string[];
	// perechile id-asset ↔ url ale pozelor entității — permit persistarea selecției în BE
	// (POST api/shares cere ogImageId); fără id, selecția rămâne doar în preview
	imageAssets?: { id: number; url: string }[];
	url?: string;
	description?: string;
}

// eticheta entității folosită în textul dialogului („Distribuie proiect”, „Distribuie anunț”…)
export const SHARE_TIP_LABEL: Record<ShareTip, string> = {
	proiect: 'proiect',
	chestionar: 'chestionar',
	anunt: 'anunț'
};

// link public per entitate; target.url are prioritate (paginile fără rută publică /share îl trimit explicit)
export function buildShareUrl(target: ShareTarget): string {
	if (target.url) return target.url;
	const origin = typeof window !== 'undefined' ? window.location.origin : '';
	return `${origin}/share/${target.tip}/${target.id}`;
}

export interface ShareContextType {
	target: ShareTarget | null;
	openShare: (target: ShareTarget) => void;
	closeShare: () => void;
}

export const ShareContext = createContext<ShareContextType>({
	target: null,
	openShare: () => {},
	closeShare: () => {}
});

export const useShareContext = (): ShareContextType => useContext(ShareContext);
